import './components/ga-events';            //should be on top of each page's JS file
import "./components/swipe-for-more";       // should be as soon as possible
import "./parts/navigation";
import "./parts/keyboard-navigation";
import "./parts/accept-cookies";
import "./parts/ftc-disclosure";
import "./components/accessibility-widget";

import tooltips from './components/tooltips';
import { shouldInitCarousel } from './components/carousel-viewport';

import "./widgets/quick-nav";
import "./components/gallery";
import "./components/js-links";
import "./components/scroll-top-btn";
import "./components/svg";
import AnimatedCounter from "./components/AnimatedCounter.js";

import './widgets/stock-price-chart';

import ExitPopup from './components/exit-popup';

import $ from "cash-dom";

import prequalState from './parts/ppc/prequalify-modal/PrequalState';

const ric = window.requestIdleCallback || ((cb) => setTimeout(cb, 1));

prequalState.isPrequalShown = false;

$(function () {
  ExitPopup.init();
  tooltips.initOnce();

  const topLoansCarousel = document.querySelector('#top_loans_carousel.carousel');

  if (shouldInitCarousel(topLoansCarousel)) {
    import('./components/Carousel').then(({ default: Carousel }) => {
      Carousel.initAll('#top_loans_carousel.carousel');
    });
  }

  const postsCarousel = document.querySelector('#posts_carousel.carousel');

  if (shouldInitCarousel(postsCarousel)) {
    import('./components/Carousel').then(({ default: Carousel }) => {
      Carousel.initAll('#posts_carousel.carousel');
    });
  }

  const animatedCounters = document.querySelectorAll('.animated-counter');
  if (animatedCounters) {
      animatedCounters.forEach((element) => {
          new AnimatedCounter(element).start();
      });
  }

  ric(() => {
      if (document.querySelector('.quiz-ui, .tiktok-quiz-ui, .quiz-pet-social-ui, .ai-quiz-ui, .quiz-tiktok-social-ui, .quiz-us-social-1-ui, .ai-compact-quiz-ui')) {
          import('./parts/ppc/quiz');
      }
  });

  if (document.querySelector('.score-info .with-score-tooltip')) {
      import('./components/score-tooltip').then(({ default: ScoreTooltip }) => {
          ScoreTooltip.init();
      });

      import('./components/score-tooltip').then(({ default: ScoreTooltip }) => {
            ScoreTooltip.init();
      });

      import('./widgets/accordion').then(({ default: Accordion }) => {
          Accordion.init();
      });
  }

  if (document.querySelector('.article-dropdown-box-container')) {
    import('./widgets/dropdown-box.js').then(({ default: DropdownBox }) => {
        DropdownBox.init();
    });
  }
});
